<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label text-primary">Año:</label>
                </div>
                <div class="col-auto">
                    <select @change="Lista" v-model="Anio" class="form-select form-control-search">
                        <option v-for="(itemY,indexY) in ListYears" :key="indexY" :value="itemY">{{itemY}}</option>
                    </select>
                </div>
            </template>
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <div class="row mt-3 mb-3">
                            <div class="col-sm-12 col-lg-6 text-center">
                                <h4 v-show="MostrarBotonCoordEspanol">Opciones Para Coordinadores</h4>
                                <button v-show="MostrarBotonCoordEspanol" @click="IrAFormulario(0,'ESP','COORDINADOR',Anio)" class="btn btn-primary">
                                    <i class="fas fa-plus-circle"></i> ESPAÑOL
                                </button>
                            </div>
                            <div class="col-sm-12 col-lg-6">
                                <h4 v-show="MostrarBotonParejaEspanol || MostrarBotonParejaIngles" class="text-center">Opciones Para Parejas</h4>
                                <div class="row">
                                    <div class="col-sm-12 col-lg-6 text-center">
                                        <button v-show="MostrarBotonParejaEspanol" @click="IrAFormulario(0,'ESP','PAREJAS',Anio)" class="text-center btn btn-primary">
                                            <i class="fas fa-plus-circle"></i> ESPAÑOL
                                        </button>
                                    </div>
                                    <div class="col-sm-12 col-lg-6 text-center">
                                        <button v-show="MostrarBotonParejaIngles" @click="IrAFormulario(0,'ENG','PAREJAS',Anio)" class="text-center btn btn-primary">
                                            <i class="fas fa-plus-circle"></i> INGLES
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="row">
                                <div class="col-lg-3" v-for="(item,index) in ListaArrayRows" :key="index">
                                    <div class="card" @click="IrAFormulario(1,item.Idioma,item.Categoria,item.Anio)" style="cursor:pointer">
                                        <div class="card-header pb-0">
                                            <h6 class="text-green-black">Encuesta de {{item.Categoria}}</h6>
                                        </div>
                                        <div class="card-body pt-0">
                                            <div class="row">
                                                <div class="col-lg-3 d-flex align-items-center">
                                                    <h1><i class="fa fa-folder-open"></i></h1>
                                                </div>
                                                <div class="col-lg-9">
                                                    <p>Idioma: {{ item.Idioma }}</p>
                                                    <h5>{{ item.Anio }}</h5>
                                                </div>
                                            </div>
                                            <hr class="horizontal dark my-3">
                                            <div class="col-12 text-end mt-n3">
                                                <button class="btn btn-link text-dark px-1 mb-0"><i class="fas fa-pencil-alt text-dark me-2"></i>Editar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </template>
                </CLoader>
                
            </template>
        </CList>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionOpcionesEncuesta';
export default {
    name: 'ListaOpcionesEncuesta',
    props: ['sFiltros','pOrigen'],
    components:{},
    data() {
        return {
            ConfigList:{
                Title: 'Opciones Base Para la Encuestas',
                IsModal: false,
                ShowEntradas:false,
                ShowSearch:false,
                ShowFiltros: true,
                ShowPaginador: false,
                TypeBody: 'Form',
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Encuesta',
                BtnNewShow:false
                // GoRoute: 'clientesform',
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],
            ListYears:[],
            Anio:'',
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            MostrarBotonCoordEspanol:true,
            MostrarBotonParejaEspanol:true,
            MostrarBotonParejaIngles:true,
            AniadirAnio:true
        }
    },
    methods: {
        async Lista(){
            this.ConfigLoad.ShowLoader=true;
            await this.$http.get("configEncuestaOpcionesBase",{
                params:{
                    Anio:this.Anio
                }
            }).then((res)=>{
                this.ListaArrayRows=res.data.data;
                this.MostrarBotonCoordEspanol=!this.ListaArrayRows.some((element)=>{
                    let result;
                    result=element.Categoria == 'COORDINADOR' && element.Idioma =='ESP';
                    return result;
                })
                this.MostrarBotonParejaEspanol=!this.ListaArrayRows.some((element)=>{
                    let result;
                    result=element.Categoria == 'PAREJAS' && element.Idioma =='ESP'
                    return result;
                })
                this.MostrarBotonParejaIngles=!this.ListaArrayRows.some((element)=>{
                    let result;
                    result=element.Categoria == 'PAREJAS' && element.Idioma =='ENG'
                    return result;
                })
                if (this.AniadirAnio) {
                    res.data.anios.forEach(element => {
                        this.ListYears.push(element);
                    });
                    this.ListYears.sort((a,b)=>{return a-b});
                    this.AniadirAnio=false;
                }
                // console.log(this.MostrarBotonCoordEspanol);
                // console.log(this.MostrarBotonParejaEspanol);
                // console.log(this.MostrarBotonParejaIngles);
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Eliminar(){

        },
        Regresar(){
            this.$router.push({name:'encuesta'});
        },
        IrAFormulario(Id,Idioma,Categoria,Anio){
            this.$router.push({name:'opcionencuestaform',params:{Id:Id,pIdioma:Idioma,pCategoria:Categoria,pAnio:Anio}})
        }
    },
    created() {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');

        this.ListYears.push(new Date().getFullYear());
        this.ListYears.push(new Date().getFullYear()+1);
        this.Anio=this.ListYears[0];
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>

<style>

</style>